import { render, staticRenderFns } from "./DbDetailEmpty.vue?vue&type=template&id=f62e7784&scoped=true&"
import script from "./DbDetailEmpty.vue?vue&type=script&lang=ts&"
export * from "./DbDetailEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./DbDetailEmpty.vue?vue&type=style&index=0&id=f62e7784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62e7784",
  null
  
)

export default component.exports